import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";

import _ from "lodash";
import {
  FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST,
  FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED,
  FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED,
} from "./actionTypes";
import {
  FetchWopiAssetDetailsErrorResponse,
  FetchWopiAssetDetailsRequest,
  FetchWopiAssetDetailsResponse,
} from "src/types/microsoftWopiIntegration";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const MICROSOFT_WOPI_INTEGRATION_BASE_URL = `${apiUrl}/api/2.0/assets/wopi`;

export const fetchWopiAssetDetails = createAction<FetchWopiAssetDetailsRequest>(
  FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST,
);

const fetchingWopiAssetDetailsSucceeded =
  createAction<FetchWopiAssetDetailsResponse>(
    FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED,
  );

const fetchingWopiAssetDetailsFailed =
  createAction<FetchWopiAssetDetailsErrorResponse>(
    FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED,
  );

const fetchWopiAssetDetailsSaga = function* (
  action: ReturnType<typeof fetchWopiAssetDetails>,
): any {
  const assetId = action.payload.assetId;

  const fetchWopiAssetDetailsAPI = () => {
    return axios({
      method: "GET",
      url: `${MICROSOFT_WOPI_INTEGRATION_BASE_URL}/discovery/${assetId}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWopiAssetDetailsAPI);
    yield put(fetchingWopiAssetDetailsSucceeded(response));
  } catch (error) {
    yield put(fetchingWopiAssetDetailsFailed({ error: error }));
  }
};

export default function* microsoftWopiIntegrationSaga() {
  yield takeEvery(
    FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST,
    fetchWopiAssetDetailsSaga,
  );
}
